import { CreateExternalEventSeriesDocument, ExternalEventSeriesCategory } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ExternalEventSeriesCreateSchemaType } from '../schemas';

export function useExternalEventSeriesCreate(data: Ref<ExternalEventSeriesCreateSchemaType>) {
    const createExternalEventSeries = useMutation(CreateExternalEventSeriesDocument);

    async function create() {
        const saveData = {
            ...toValue(data),
            category: (toValue(data).category?.id as ExternalEventSeriesCategory) ?? null,
        };
        const res = await createExternalEventSeries.mutate(saveData);
        const { id } = res?.data?.create?.externalEventSeries ?? {};
        if (id) {
            return { id, errors: [] };
        }
        return { id: undefined, errors: res?.errors };
    }

    return {
        create,
    };
}
